import React from "react";
import { observer } from "mobx-react";
import { WorkAuthorUpdateStore } from "../../store";
import { WorkAuthorUpdateForm } from "./WorkAuthorUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type WorkAuthorUpdateProps = {
  workAuthorUpdateStore: WorkAuthorUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const WorkAuthorUpdate: React.FC<WorkAuthorUpdateProps> = observer(
  ({ workAuthorUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={workAuthorUpdateStore.isSaving} />
        <WorkAuthorUpdateForm
          workAuthorUpdateStore={workAuthorUpdateStore}
          authorError={workAuthorUpdateStore.errors.author?.message}
          onAuthorChange={(value) => {
            workAuthorUpdateStore.setAuthorValue(value);
          }}
          authorSelectedValue={workAuthorUpdateStore.entityValues.showAuthor}
          onAuthorSelected={(value) => {
            workAuthorUpdateStore.setSelectedAuthor(value);
          }}
          authorOptions={workAuthorUpdateStore.getAuthorOptions()}
          lyricsPercentageError={
            workAuthorUpdateStore.errors.lyricsPercentage?.message
          }
          onLyricsPercentageChange={(value: number) => {
            workAuthorUpdateStore.setLyricsPercentageValue(value);
          }}
          lyricsPercentage={workAuthorUpdateStore.entityValues.lyricsPercentage}
          musicPercentageError={
            workAuthorUpdateStore.errors.musicPercentage?.message
          }
          onMusicPercentageChange={(value: number) => {
            workAuthorUpdateStore.setMusicPercentageValue(value);
          }}
          musicPercentage={workAuthorUpdateStore.entityValues.musicPercentage}
          workAuthorPublisherUpdateStore={
            workAuthorUpdateStore.publishersUpdateStore
          }
          publishersVisibleColumns={
            workAuthorUpdateStore.publishersVisibleColumns
          }
          publishersColumnTypes={workAuthorUpdateStore.publishersColumnTypes}
          publishersOnRestore={(id: string) =>
            workAuthorUpdateStore.publishersRestore(id)
          }
          publishersOnCommitChanges={(changes) =>
            workAuthorUpdateStore.publishersCommitChanges(changes)
          }
          publishersOnCommitInlineChange={(rowId, changes) =>
            workAuthorUpdateStore.publishersCommitInlineChange(rowId, changes)
          }
          publishersValidateChanges={(changes) =>
            workAuthorUpdateStore.publishersValidateChanges(changes)
          }
          publishersRows={workAuthorUpdateStore.entityValues.showPublishers}
          publishersError={workAuthorUpdateStore.errors.publishers?.message}
          dummyCRUDRestoredObservable={
            workAuthorUpdateStore.dummyCRUDRestoredObservable
          }
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={workAuthorUpdateStore.saveDisabled}
          onSave={() => workAuthorUpdateStore.saveWorkAuthor()}
          onCancel={() => workAuthorUpdateStore.cancelWorkAuthor()}
          viewFormAuthor={() => workAuthorUpdateStore.viewFormAuthor()}
        />
        <ErrorDialog
          open={workAuthorUpdateStore.errorDialogOpened}
          title={workAuthorUpdateStore.errorTitle}
          description={workAuthorUpdateStore.errorDescription}
          onClose={() => workAuthorUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={workAuthorUpdateStore.confirmDialogOpened}
          title={workAuthorUpdateStore.confirmDialogTitle}
          description={workAuthorUpdateStore.confirmDialogDescription}
          onConfirm={() => workAuthorUpdateStore.executeConfirmedAction()}
          onCancel={() => workAuthorUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
